export default __webpack_public_path__ + "static/media/georgiaMap.3ebf6734.png";